import { Component, Input, OnInit } from "@angular/core";
import { TranslocoPipe } from "@jsverse/transloco";
import { EffectivenessTaskCounts } from "../../../shared/models/effectiveness-taskcounts";
import { EffectivenessModel } from "../../../shared/models";
import { DateFormatPipe } from "@app/shared/pipes/date-format.pipe";
import { EffIconComponent } from "../../common/eff-icon/eff-icon.component";

@Component({
    selector: "eff-control-task-count-info-box",
    templateUrl: "./eff-control-task-count-info-box.component.html",
    styleUrls: ["./eff-control-task-count-info-box.component.scss"],
    imports: [TranslocoPipe, DateFormatPipe, EffIconComponent]
})
export class EffControlTaskCountInfoBoxComponent implements OnInit {
    @Input() taskCounts: EffectivenessTaskCounts;
    @Input() effectivenessModel: EffectivenessModel;
    @Input() icon: string = "warning";

    periodOngoing: boolean = true;

    constructor() {}

    ngOnInit() {
        this.periodOngoing = Date.now() - new Date(this.effectivenessModel.endDate).getTime() < 0;
    }
}
